module.exports = __webpack_public_path__ + "img/logo-safras-icon.8d28971b.svg";